

import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom"; // Added useHistory
import AddClient from "../components/Invoice/AddClient";
import AddSupplier from "../components/Suppliers/AddSupplier";
import AddStaff from "../components/Staff/AddStaff";
import DSRDialog from "../components/Invoices/DSRDialog";
import usePermissions from "../utils/permissions";
import * as api from "../api/index";

import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Button, // Added Button
  Avatar, // Added Avatar
  Popper, // Added Popper
  Grow, // Added Grow
  Paper, // Added Paper
  ClickAwayListener, // Added ClickAwayListener
  MenuList, // Added MenuList
} from "@material-ui/core";
import { AppContext } from "../Context/AppContext";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useSeatless } from "../Context/SeatlessContext";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  PermIdentity as PermIdentityIcon,
  GroupAdd as GroupAddIcon,
  Add as AddIcon,
  Assignment,
} from "@material-ui/icons";
import { useDispatch } from "react-redux"; // Added useDispatch

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const CartHeader = ({ classes, theme, handleDrawerClose, invoices }) => {
  const [anchorEl, setAnchorEl] = useState(null); // For the Add Options menu
  const [openProfile, setOpenProfile] = useState(false); // For the profile dropdown
  const user = JSON.parse(localStorage.getItem("profile"));
  const [openClient, setOpenClient] = useState(false);
  const [openSupplier, setOpenSupplier] = useState(false);
  const { seatlessMode, setSeatlessMode, toggleLocked } = useSeatless();

  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    canReadPage,
    isAdmin,
    // canDownloadReports,
  } = usePermissions();

  // State for permissions and loading
  const [canDownloadReports, setcanDownloadReports] = useState(false);
  const [isAdminn, setIsAdminn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch permissions from database
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found");
        setIsAdminn(profile?.result?.userType?.includes("admin") || false);

        const { data } = await api.getUserPermissions();
        setcanDownloadReports(data.canDownloadPdfReports || false);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching permissions:", error.message);
        setcanDownloadReports(false); // Fallback to no permission
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);

  const handleSeatlessToggle = async (e) => {
    const next = e.target.checked;
    setSeatlessMode(next);
  };

  const [openStaff, setOpenStaff] = useState(false);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    startDateDSR,
    setStartDateDSR,
    endDateDSR,
    setEndDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  const dispatch = useDispatch(); // For logout action
  const history = useHistory(); // For navigation
  const anchorRef = React.useRef(null); // Ref for profile button

  // Handlers for Add Options menu
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // Handlers for Profile dropdown
  const handleProfileToggle = () => {
    setOpenProfile((prevOpen) => !prevOpen);
  };
  const handleProfileClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenProfile(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenProfile(false);
    }
  };
  const openLink = (link) => {
    history.push(`/${link}`);
    setOpenProfile(false);
  };
  const logout = () => {
    dispatch({ type: "LOGOUT" });
    history.push("/");
    window.location.reload();

  };

  // Handlers for DSR dialog
  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };
  
  const handleStartDateChange = (newDate) => {
    setStartDateDSR(newDate);
    setShowPreviewDSR(false);
  };
  
  const handleEndDateChange = (newDate) => {
    setEndDateDSR(newDate);
    setShowPreviewDSR(false);
  };
  
  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };
  const handleCloseDSR = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };

  // Ensure focus returns to button after closing profile menu
  const prevOpen = React.useRef(openProfile);
  React.useEffect(() => {
    if (prevOpen.current === true && openProfile === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openProfile;
  }, [openProfile]);

  return (
    <>
      <AddClient setOpen={setOpenClient} open={openClient} />
      <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
      <AddStaff setOpen={setOpenStaff} open={openStaff} />
      <div className={classes.drawerHeader}>
        <Tooltip title="Close Drawer" arrow>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Settings" arrow>
          <Link to="/settings" style={{ textDecoration: "none" }}>
            <IconButton aria-label="delete" disabled color="primary">
              <SettingsIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Link>
        </Tooltip>

        {isAdmin() && (
          <Tooltip title="Admin Dashboard" arrow>
            <a href="/admindashboard" style={{ textDecoration: "none" }}>
              <IconButton aria-label="delete" disabled color="primary">
                <GroupAddIcon style={{ fontWeight: "bold", color: "black" }} />
              </IconButton>
            </a>
          </Tooltip>
        )}
        {/* <Tooltip title="Add Options" arrow>
          <IconButton
            aria-controls="customized-menu"
            aria-haspopup="true"
            variant="contained"
            onClick={handleClick}
          >
            <PermIdentityIcon style={{ fontWeight: "bold", color: "black" }} />
          </IconButton>
        </Tooltip>
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {(isAdmin() || canReadPage("Customer")) && (
            <StyledMenuItem
              disabled={
                permissionsLoading || (!isAdmin() && !canCreatePage("Customer"))
              }
              style={{
                cursor:
                  permissionsLoading ||
                  (!isAdmin() && !canCreatePage("Customer"))
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={() => setOpenClient(true)}
            >
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Customer" />
            </StyledMenuItem>
          )}
          <StyledMenuItem onClick={() => setOpenSupplier(true)}>
            <ListItemIcon>
              <AddIcon
                fontSize="small"
                style={{ fontWeight: "bold", color: "black" }}
              />
            </ListItemIcon>
            <ListItemText primary="Supplier" />
          </StyledMenuItem>
        </StyledMenu> */}
        {/* <Tooltip title="Help" arrow>
          <Link to="/help" style={{ textDecoration: "none" }}>
            <IconButton aria-label="delete" disabled color="primary">
              <HelpIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Link>
        </Tooltip> */}

        <Tooltip title="Daily Sales Report" arrow>
          <IconButton
            aria-controls="customized-menu"
            disabled={loading || (!isAdminn && !canDownloadReports)}
            style={{
              cursor:
                loading || (!isAdminn && !canDownloadReports)
                  ? "not-allowed"
                  : "pointer",
            }}
            aria-haspopup="true"
            variant="contained"
            onClick={() => setOpenDSR(true)}
          >
            <Assignment style={{ fontWeight: "bold", color: "black" }} />
          </IconButton>
        </Tooltip>
        <div style={{ marginLeft: 8 }}>
          <FormControlLabel
            control={<Switch checked={seatlessMode} onChange={handleSeatlessToggle} color="primary" disabled={toggleLocked} />}
            label="Crowd Mode"
          />
        </div>
        <DSRDialog
          open={openDSR}
          onClose={handleCloseDSR}
          date={dateDSR}
          handleDateChange={handleDateChange}
          startDate={startDateDSR}
          handleStartDateChange={handleStartDateChange}
          endDate={endDateDSR}
          handleEndDateChange={handleEndDateChange}
          handleSubmit={handleSubmit}
          showPreview={showPreviewDSR}
          rows={invoices}
          user={user}
          classes={classes}
        />

        {/* Profile Icon Section (Copied from Header) */}
        <div style={{ marginLeft: "auto" }}>
          <Tooltip title="Profile" arrow>
            <Button
              ref={anchorRef}
              aria-controls={openProfile ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleProfileToggle}
            >
              <Avatar
                style={{
                  backgroundColor: "white",
                  color: "#ef7f1a",
                  border: "1px solid",
                }}
              >
                {user?.result?.name?.charAt(0)}
              </Avatar>
            </Button>
          </Tooltip>
          <Popper
            open={openProfile}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 9999 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper elevation={3}>
                  <ClickAwayListener onClickAway={handleProfileClose}>
                    <MenuList
                      autoFocusItem={openProfile}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={() => openLink("settings")}>
                        {(user?.result?.name).split(" ")[0]}
                      </MenuItem>
                      <MenuItem onClick={() => openLink("help")}>
                        {"Help".split(" ")[0]}
                      </MenuItem>
                      <MenuItem onClick={() => logout()}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    </>
  );
};

export default CartHeader;
